import { useEffect, useLayoutEffect } from 'react'

/**
 * useIsomorphicLayoutEffect
 *
 * A hook that uses useLayoutEffect on the client and useEffect on the server.
 * This prevents SSR warnings when using layout effects that access DOM APIs.
 *
 * Use this instead of useLayoutEffect when:
 * - You need to measure or manipulate the DOM synchronously before paint
 * - The component needs to be SSR compatible
 * - You're using browser-only APIs (GSAP, ScrollTrigger, etc.)
 */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect
